export default __webpack_public_path__ + "static/media/tip2Wrong.579076df.svg";